module.exports = __webpack_public_path__ + "static/media/thermage_eyes_focus.55fbf259.mov";